import { createAction } from 'redux-actions';
import * as types from './actionTypes';
import { payloadCreator, metaCreator, createAsyncActions } from './helpers';
import { sendDataAction } from './postMessageAction';

// postMessage (window api redux flow)
export const postMessage = sendDataAction;

// publish display alerts (DISPLAY_ALERTS)
export const publishAlert = createAction(
  types.CREATE_ALERT,
  payloadCreator,
  metaCreator
);

export const removeAlert = createAction(types.DELETE_ALERT, () => { }, metaCreator);

// Browser Storage Actions
export const setStorageItem = createAction(
  types.SET_BROWSER_STORAGE_ITEM,
  payloadCreator,
  metaCreator
);

export const clearStorageItem = createAction(
  types.CLEAR_BROWSER_STORAGE_ITEM,
  payloadCreator,
  metaCreator
);

export const getStorageItems = createAction(
  types.GET_BROWSER_STORAGE_ITEMS,
  () => {},
  () => {}
);

// // location change
export const publishLocation = createAction(
  types.LOCATION_CHANGE,
  payloadCreator,
  metaCreator
);

// ///// images ///// //
export const [
  uploadCroppedImageRequest, uploadCroppedImageSuccess, uploadCroppedImageFailure
] = createAsyncActions(types.UPLOAD_CROPPED_IMAGE);

// // ///// users ///// //
export const [
  getCurrentUserInfo, getCurrentUserInfoSuccess, getCurrentUserInfoFailure
] = createAsyncActions(types.LOAD_CURRENT_USER_INFO);

export const clearUserSession = createAction(
  types.CLEAR_USER_SESSION,
  payloadCreator,
  metaCreator
);

export const [
  queryCustomerPermissions, queryCustomerPermissionsSuccess, queryCustomerPermissionsFailure
] = createAsyncActions(types.LOAD_CUSTOMER_PERMISSIONS);

// pagination
export const configurePagination = createAction(
  types.CONFIGURE_PAGINATION,
  payloadCreator,
  metaCreator
);

export const sortBy = createAction(types.SORT_BY, payloadCreator);

// Job Form /////
export const [
  getMagicAlgorithmResultsRequest, getMagicAlgorithmResultsSuccess, getMagicAlgorithmResultsFailure
] = createAsyncActions(types.GET_MAGIC_ALGORITHM_RESULTS);

export const [
  getRequirementsTagsRequest, getRequirementsTagsSuccess, getRequirementsTagsFailure
] = createAsyncActions(types.GET_REQUIREMENTS_TAGS);

export const [
  getFillAdvisorDataRequest, getFillAdvisorDataSuccess, getFillAdvisorDataFailure
] = createAsyncActions(types.GET_FILL_ADVISOR_DATA);

export const updateJobFormActiveSection = createAction(
  types.JOB_FORM_UPDATE_ACTIVE_SECTION,
  payload => payload,
  metaCreator
);

export const updateJobFormValidSection = createAction(
  types.JOB_FORM_UPDATE_VALID_SECTIONS,
  payloadCreator,
  metaCreator
);

export const clearJobFormSectionData = createAction(
  types.JOB_FORM_CLEAR_SECTION_DATA,
  () => {},
  metaCreator
);

export const setJobFormValidSections = createAction(
  types.JOB_FORM_SET_VALID_SECTIONS,
  payload => payload,
  metaCreator
);

export const trackSegmentEvent = createAction(
  types.TRACK_SEGMENT_EVENT,
  payload => payload,
  metaCreator
);

export const updateFeatureUserSettings = createAction(
  types.UPDATE_FEATURE_USER_SETTINGS,
  payload => payload,
  metaCreator
);

export const clearFeatureUserSettings = createAction(
  types.CLEAR_FEATURE_USER_SETTINGS,
  payload => payload,
  metaCreator
);

export const getFeatureUserSettings = createAction(
  types.LOAD_FEATURE_USER_SETTINGS.REQUEST,
  payloadCreator,
  metaCreator
);

export const getFeatureUserSettingsSuccess = createAction(
  types.LOAD_FEATURE_USER_SETTINGS.SUCCESS,
  payloadCreator,
  metaCreator
);

export const getFeatureUserSettingsFailure = createAction(
  types.LOAD_FEATURE_USER_SETTINGS.FAILURE,
  payloadCreator,
  metaCreator
);

export const selectMessageThread = createAction(
  types.SELECT_JOB_ID_OF_MESSAGE_THREAD,
  payloadCreator,
  metaCreator
);

export const selectAllMessages = createAction(
  types.SELECT_ALL_MESSAGE_THREADS,
  payloadCreator,
  metaCreator
);

export const clearMessageThreadSelections = createAction(
  types.CLEAR_MESSAGE_THREAD_SELECTIONS,
  payloadCreator,
  metaCreator
);

export const setMessageModalJobId = createAction(
  types.SET_MESSAGE_MODAL_JOB_ID,
  payloadCreator,
  metaCreator
);

export const setWandaVenueModalData = createAction(
  types.SET_WANDA_VENUE_MODAL_DATA,
  payloadCreator,
  metaCreator
);

export const setSimplifiedJobPostingData = createAction(
  types.SET_SIMPLIFIED_JOB_POSTING_DATA,
  payloadCreator,
  metaCreator
);

export const selectWonoloerPreferredModal = createAction(
  types.PREFERRED_MODAL_SELECT_WONOLOER,
  payloadCreator,
  metaCreator
);

export const selectTeamPreferredModal = createAction(
  types.PREFERRED_MODAL_SELECT_TEAM,
  payloadCreator,
  metaCreator
);

export const hydratePreferredModal = createAction(
  types.PREFERRED_MODAL_HYDRATE,
  payloadCreator,
  metaCreator
);

export const updateIsClosedPreferredPreferredModal = createAction(
  types.PREFERRED_MODAL_UPDATE_IS_CLOSED_PREFERRED,
  payloadCreator,
  metaCreator
);
